import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'

interface NavigationType {
  discover: {
    marketplaceModules: {
      item: {
        fullPath: (params: { id: string }) => string
      }
    }
  }
}

interface ModalFooterProps {
  onRequestInfo: () => void
  navigation: NavigationType
  slug?: string
  moduleName?: string | null
  onClose: () => void
  isRequesting: boolean
}

const ModalFooter = ({
  onRequestInfo,
  navigation,
  slug,
  moduleName,
  onClose,
  isRequesting,
}: ModalFooterProps) => {
  const navigate = useNavigate()
  const { getDetailPath } = useMarketplaceModulesPath()

  return (
    <Box
      flexDirection="row"
      gap="s8"
      alignSelf="flexEnd"
      padding="s16"
      width="full"
      border={{ top: { color: 'grey400', style: 'solid', width: 's1' } }}
      justifyContent="flexEnd"
    >
      <F0Button
        onClick={() => {
          track(trackingEvents.marketplaceModules.goToModuleDetailPage, {
            origin: slug ?? '',
            source: 'Request Upsell Modules Modal',
          })
          navigate(getDetailPath(slug ?? moduleName ?? ''))
          onClose()
        }}
        variant="outline"
        label={i18n.t('upsell.request_modal.learn_more')}
        loading={isRequesting}
        disabled={isRequesting}
      />
      <F0Button
        onClick={onRequestInfo}
        variant="promote"
        label={i18n.t('upsell.request_modal.cta')}
        loading={isRequesting}
      />
    </Box>
  )
}

export default ModalFooter
